import { useState, useEffect } from "react"

// https://usehooks.com/useOnScreen/

export default (ref, threshold = 0.25, timeout = 1500) => {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    const element = ref.current
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIntersecting(true)
          observer.unobserve(entry.target)
        }
      },
      {
        threshold,
      }
    )
    if (element) {
      setTimeout(() => observer.observe(element), timeout)
    }
    return () => {
      if (typeof element === Element) observer.unobserve(element)
      else observer.disconnect()
    }
  }, [ref, threshold, timeout])
  return isIntersecting
}
